import * as moment from "moment";
export const isDateBetween = (startDate: string, endDate: string) => {
// console.log(startDate, endDate)
    const _startDate = moment(startDate, "DD/MM/YYYY HH:mm:ss");
    const _endDate = moment(endDate, "DD/MM/YYYY HH:mm:ss");
    // console.log(_startDate, _endDate)
    // console.log(moment())

    return moment().isBetween(_startDate, _endDate);

  }
